const initialState = {
  scrollTop: 0,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'SCROLL_TOP_CHANGED':
      return Object.assign({}, state, {
        scrollTop: action.scrollTop,
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/large-card-framework.js
 **/